import { render, staticRenderFns } from "./confirmList.vue?vue&type=template&id=708d2d9a&"
import script from "./confirmList.vue?vue&type=script&lang=js&"
export * from "./confirmList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports